import { 
  baseApi,
  select,
} from './base';

import {
  templateType
} from '../graphqlTypes';

const templateApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getTemplates: select(builder, 'template', templateType, false, {
      order: `{name: asc}`,
    })
  }),
  overrideExisting: false,
});

export const { 
  useGetTemplatesQuery
} = templateApi